import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { AdHocTokenIssue, IAdHocSmsSegment } from '../../../lib/types';
import { SmsCharacterCounter } from '../ComposePanel/sms-character-counter.component';
import { messages } from './preview-panel.messages';
import { SmsBody, SmsBubble, SmsMark } from './preview-panel.styles';

// Presentational map from the server's segment issue to the shared kebab
// data-issue attribute the email doc's mark CSS also keys on — not a tokenizer.
const ISSUE_ATTR: Record<AdHocTokenIssue, string> = {
  UNKNOWN: 'unknown',
  MISSING_FALLBACK: 'missing-fallback'
};

interface ISmsPreviewBubbleProps {
  // Server-split parts of the resolved SMS; `issue` marks a still-unresolved token.
  segments: IAdHocSmsSegment[];
  // Fully-resolved SMS text — feeds the segment counter (length is per-recipient).
  smsBody?: string;
}

export const SmsPreviewBubble: React.FC<ISmsPreviewBubbleProps> = ({ segments, smsBody }) => (
  <SmsBody>
    <SmsBubble>
      {segments.map((segment, index) => (
        segment.issue
          ? (
            <SmsMark key={`seg-${index}`} data-issue={ISSUE_ATTR[segment.issue]}>
              {segment.text}
            </SmsMark>
          )
          : <React.Fragment key={`seg-${index}`}>{segment.text}</React.Fragment>
      ))}
    </SmsBubble>
    <SmsCharacterCounter value={smsBody || ''} />
    <Box mt={0.5}>
      <Typography variant="caption" color="textSecondary">
        <IntlMsg {...messages.smsLengthVaries} />
      </Typography>
    </Box>
  </SmsBody>
);
